import {
  parseBoardList,
  parseBoardMetadata,
} from "@/config/developmentBoardRuntime";
import type { AddedBoard } from "@/features/settings/stores/mixStore";
import { apiGet } from "@/shared/api/client";

/** 既存の設定済みAPI originだけで板の登録と名前を確認する。 */
export async function fetchAddedBoard(
  slug: string,
  signal: AbortSignal,
): Promise<AddedBoard> {
  const value = await apiGet<unknown>(`/boards/${encodeURIComponent(slug)}`, {
    signal,
    redirect: "error",
    credentials: "omit",
    cache: "no-store",
  });
  const board = parseBoardMetadata(value, slug);
  if (board === null) throw new Error("板情報の形式が不正です");
  return {
    slug: board.slug,
    boardName: board.boardName,
    presentation: board.presentation,
  };
}

/** 成功した登録一覧だけを同期に使う。通信失敗を空の一覧へ変換しない。 */
export async function fetchRegisteredBoards(
  signal: AbortSignal,
): Promise<readonly AddedBoard[]> {
  const value = await apiGet<unknown>("/boards", {
    signal,
    redirect: "error",
    credentials: "omit",
    cache: "no-store",
  });
  const boards = parseBoardList(value);
  if (boards === null) throw new Error("板一覧の形式が不正です");
  return boards;
}
